import { create } from "zustand";
import {toast} from "react-toastify";
import { useI18nStore } from "./i18n.store";

const defaultSelectedColumns = [
    "invoice_number",
    "description",
    "invoice_date",
    "invoice_due_date",
    "total_amount_currency",
    "status"
];

export const useInvoicesTableStore = create((set, get) => {
    return {
        selectedColumns: [...defaultSelectedColumns],
        getAvailableColumns: () => {
            const t = useI18nStore.getState().t;
            return {
                "invoice_id": "ID faktury",
                "invoice_number": t("invoices.invoiceNumber"),
                "opportunity_id": t("invoices.opportunityId"),
                "description": t("common.description"),
                "invoice_date": "Vystaveno",
                "invoice_due_date": "Splatnost",
                "invoice_tax_date": t("invoices.taxableDate"),
                "invoice_paid_date": "Zaplaceno",
                "status": t("common.state"),
                "issued_by": "Vystavil",
                "total_amount_currency": t("invoices.amount"),
            };
        },
        toggleColumn: (key) => {
            const t = useI18nStore.getState().t;
            if (!get().selectedColumns.includes(key)) {
                if (get().selectedColumns.length >= 7) {
                    toast.error(t("users.cannotSelectMoreColumns"));
                    return;
                }
            }

            set((state) => ({
                selectedColumns: state.selectedColumns.includes(key)
                    ? state.selectedColumns.filter((col) => col !== key)
                    : [...state.selectedColumns, key],
            }))
        },
    };
});